(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Mobile drawer pill tab switching (L1 → L2 panels)
  document.addEventListener('DOMContentLoaded', function () {
    function initDrawerTabs(drawer) {
      const topbar = drawer.querySelector('[data-drawer-tabs]');
      const panelsContainer = drawer.querySelector('[data-drawer-panels]');
      if (!topbar || !panelsContainer) return;

      topbar.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-panel-trigger]');
        if (!trigger) return;
        e.preventDefault();

        const panelHandle = trigger.getAttribute('data-panel-trigger');

        // Update pill active states
        topbar.querySelectorAll('[data-panel-trigger]').forEach(function (btn) {
          const isActive = btn.getAttribute('data-panel-trigger') === panelHandle;
          btn.classList.toggle('menu-drawer__pill--active', isActive);
          btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        // Update panel active states
        panelsContainer.querySelectorAll('.menu-drawer__panel').forEach(function (panel) {
          const isActive = panel.id === 'MobileDrawerPanel-' + panelHandle;
          panel.classList.toggle('menu-drawer__panel--active', isActive);
        });
      });
    }

    document.querySelectorAll('header-drawer').forEach(function (drawer) {
      initDrawerTabs(drawer);
    });

    // Re-init when drawer opens (for lazy-rendered content)
    document.addEventListener('header-drawer:open', function (e) {
      if (e.detail && e.detail.drawer) {
        initDrawerTabs(e.detail.drawer);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncVars() {
      var col = document.querySelector('.header__column--left');
      if (!col) return;
      var r = col.getBoundingClientRect();
      var hdr = document.getElementById('header-component');
      var isSticky = hdr && hdr.getAttribute('data-sticky-state') === 'active';
      if (isSticky) {
        document.documentElement.style.setProperty('--nav-sub-top', (r.bottom + 10) + 'px');
      }
      document.documentElement.style.setProperty('--nav-sub-left',  r.left + 'px');
      document.documentElement.style.setProperty('--nav-sub-width', col.offsetWidth + 'px');
    }
    syncVars();
    window.addEventListener('resize', syncVars, { passive: true });
    document.addEventListener('pointerenter', function (e) {
      if (e.target && e.target.closest && e.target.closest('header-menu')) syncVars();
    }, true);

    // When data-sticky-state changes (transparent ↔ sticky transition),
    // instantly hide all submenus so the position switch is invisible.
    var hdr = document.getElementById('header-component');
    if (hdr && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'data-sticky-state') {
            var subs = document.querySelectorAll('header-menu .menu-list__submenu');
            subs.forEach(function (sub) {
              sub.style.setProperty('opacity',     '0',      'important');
              sub.style.setProperty('visibility',  'hidden', 'important');
              sub.style.setProperty('transition',  'none',   'important');
            });
            setTimeout(function () {
              subs.forEach(function (sub) {
                sub.style.removeProperty('opacity');
                sub.style.removeProperty('visibility');
                sub.style.removeProperty('transition');
              });
            }, 300);
            break;
          }
        }
      }).observe(hdr, { attributes: true, attributeFilter: ['data-sticky-state'] });
    }
    // Prevent href="#" L1 links from jumping to the page top.
    // Merchants can use "#" in the nav editor as a non-linking parent item.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('header-menu .menu-list__link[href="#"]');
      if (link) e.preventDefault();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
